
import ContactSection from "../components/contact/ContactUs";
import Footer from "../components/footer/Footer";
import "../components/cart/Cart.css"
import Navbar from "../components/navbar/Navbar";
import Banner from "../components/banner/Banner";
import { useEffect } from "react";


const Contact=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
<div className="bg-imagea">
<Navbar/>
<Banner title="Contact"/>
<ContactSection/>
<Footer/>
</div>
    )
}
export default Contact;